import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";

export interface SelectNumberProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  min: number;
  max: number;
}

function SelectNumber({ value, min, max, ...rest }: SelectNumberProps) {
  const options = Array(max - min + 1)
    .fill(null)
    .map((_, index) => {
      const value = index + min;

      return {
        label: value,
        value,
      };
    });

  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      defaultValue={null}
      options={options}
      {...rest}
    />
  );
}

export default SelectNumber;
